import { useTranslation } from "react-i18next";

import { Arrange, EmptyState, Separator } from "@aviary";
import { l } from "@emerson/locales/i18n";

import { FreeShippingBar } from "../FreeShippingBar/FreeShippingBar";

import * as styles from "./EmptyCart.styles";
const EmptyCart = () => {
  const { t } = useTranslation();

  return (
    <Arrange isVertical spacing="xxsmall" justify="center" isFullWidth>
      <EmptyState
        css={styles.wrapper}
        illustration="emptyBottle"
        header={t(l.cart.CartEmpty)}
        isBorderless
      />
      <Separator css={styles.separator} />
      <FreeShippingBar />
    </Arrange>
  );
};

export { EmptyCart };
